import * as sagas from '../helpers/sagas';
import { types } from '../actions/search';
import { api } from '../resources/search';

const takeLatest = [
  {
    type: types.SEARCH_QUERY,
    call: api.query,
  },
];

const search = takeLatest.map(sagas.makeTakeLatest);

export default search;



// WEBPACK FOOTER //
// ./src/sagas/search.js